export default __webpack_public_path__ + "static/warnings-light-mode-3af1871a4997f24bcffbbae76d714043.png";